import { render, staticRenderFns } from "./EditarHistorialModal.vue?vue&type=template&id=474013e6&scoped=true&"
import script from "./EditarHistorialModal.vue?vue&type=script&lang=ts&"
export * from "./EditarHistorialModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditarHistorialModal.vue?vue&type=style&index=0&id=474013e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474013e6",
  null
  
)

export default component.exports